import { IThemeEnum } from "../../../types/theme";
import { useAppSelector } from "../../hooks";
import Directory from "./Directory";
import ServiceSelectionOld from "./ServiceSelectionOld";



const LaunchPad: React.FC = () => {
  const { theme } = useAppSelector(state => state.theme);
  return theme.theme === IThemeEnum.vertical ? <Directory /> : <ServiceSelectionOld />;
};

export default LaunchPad;
